import { InfoIcon } from "lucide-react"
import type { ReactNode } from "react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/primitives/tooltip.tsx"

/**
 * What a figure or a heading means, behind a quiet info icon beside it, so the definition is a hover
 * away rather than a paragraph in the way. `about` names what it explains, for a screen reader.
 */
export function HelpTooltip({ about, children }: { about: string; children: ReactNode }) {
  return (
    <Tooltip>
      <TooltipTrigger
        aria-label={`About ${about}`}
        className="inline-flex rounded-sm text-subtle-foreground transition-colors duration-100 ease-snappy hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        <InfoIcon aria-hidden className="size-3.5" />
      </TooltipTrigger>
      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  )
}
